import React from 'react';
import PropTypes from 'prop-types';
import {
  DtpSelect,
} from 'dtp-react-components';

const Select = (props) => {
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange(e);
    }
    if (props.onBlur) {
      props.onBlur(e);
    }
  };

  // const renderSelectItem = item => ({
  //   value: item.value,
  //   label: item.label,
  // });

  // const placeholder = props.placeholder ? ([{
  //   value: null,
  //   label: props.placeholder,
  // }]) : [];

  // const listRendered = props.itemList.map(item => renderSelectItem(item));

  // placeholder.push(...listRendered);
  // const lista = placeholder;
  const options = props.itemList.map(item => (<option value={item.value}>{item.label}</option>));
  if (props.custom) {
    return (
      <select
        value={props.value !== undefined && props.value !== null ? props.value : ''}
        disabled={props.disabled || props.itemList.length === 0}
        className="form-control"
        onChange={e => handleChange(e.target.value)}
        style={{
          backgroundColor: '#ffffff',
          border: 'none',
          borderBottomStyle: 'none',
          borderBottomWidth: 'medium',
          borderBottom: '2px solid #b7c4cb',
          borderBottomColor: props.value ? '#27ae60' : '#b7c4cb',
          borderRadius: '0',
          boxShadow: 'none',
          color: '#78909c',
          fontSize: '1.6rem',
          WebkitAppearance: 'none',
          MozAppearance: 'none',
          textIndent: '1px',
          textOverflow: '',
          '&::after': {
            boxShadow: 'none',
            color: '#78909c',
            borderBottomColor: '#27ae60',
            borderBottom: '2px solid #27ae60',
            cursor: 'pointer',
            fontSize: '3rem',
            fontFamily: 'libicons',
            position: 'absolute',
            WebkitAppearance: 'none',
            MozAppearance: 'none',
            top: '30%',
            right: '.5rem',
            content: '"\\E921"',
            zIndex: '98',
          },
        }}
      >
        { !props.disabled ?
          <option value="">{props.placeholder}</option>
          :
          <option value="" /> }
        {options}
      </select>
    );
  }
  return (
    <DtpSelect
      custom={props.custom}
      onSelect={handleChange}
      placeholder={props.placeholder}
      value={props.value !== undefined && props.value !== null ? props.value : ''}
      disabled={props.disabled || props.itemList.length === 0}
      items={props.itemList}
    />
  );
};

Select.defaultProps = {
  custom: false,
  disabled: false,
  onBlur: null,
  placeholder: null,
  value: null,
};

Select.propTypes = {
  custom: PropTypes.bool,
  /** Lista de itens a serem disponibilizados */
  itemList: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    label: PropTypes.string,
  })).isRequired,
  /** Configura a function a ser chamada ao retirar o foco do input */
  onBlur: PropTypes.func,
  /** Configura a function a ser chamada para mudanca de valor */
  onChange: PropTypes.func.isRequired,
  /** Label a ser colocado na posicao zero */
  placeholder: PropTypes.string,
  /** Configura o valor selecionado */
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  // Desativar input
  disabled: PropTypes.bool,
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/Select.jsx